export default __webpack_public_path__ + "static/media/footer-border.2796009b.svg";